import { InternalUserRoles } from "../../constants/roles";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import MIDASWorkRequests from "../../pages/WorkRequests";
import NewSpecialAnalysis from "../../pages/SpecialAnalysis/NewSpecialAnalysis";
import NewWorkRequestRedesign from "../../pages/WorkRequests/NewWorkRequestRedesign";
import ViewSpecialAnalysis from "../../pages/SpecialAnalysis/ViewSpecialAnalysis/ViewSpecialAnalysis";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/workRequests";

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: MIDASWorkRequests,
  allowedRoles: InternalUserRoles,
  label: "Requests",
  icon: () => <RoomServiceIcon />,
  isCustomIcon: false,
  hasDivider: false,
};

export const requestsRoutes: { [key: string]: RouteConfig } = {
  requests: baseRoute,
  processWorkRequest: {
    path: "/processWorkRequests",
    component: () => <MIDASWorkRequests initialTabValue={1} />,
    allowedRoles: InternalUserRoles,
  },
  newSpecialAnalysis: {
    path: "/newSpecialAnalysis",
    component: NewSpecialAnalysis,
    allowedRoles: InternalUserRoles,
  },
  newWorkRequestRedesign: {
    path: "/newWorkRequestRedesign",
    component: NewWorkRequestRedesign,
    allowedRoles: InternalUserRoles,
  },
  newWorkRequestRedesignDetail: {
    path: "/newWorkRequestRedesign/:id",
    component: NewWorkRequestRedesign,
    allowedRoles: InternalUserRoles,
  },
  viewSpecialAnalysisDetail: {
    path: "/viewSpecialAnalysis/:id",
    component: ViewSpecialAnalysis,
    allowedRoles: InternalUserRoles,
  },
  processSpecialAnalysis: {
    path: "/processSpecialAnalysis",
    component: () => <MIDASWorkRequests initialTabValue={2} />,
    allowedRoles: InternalUserRoles,
  },
};
